/**
 * The purpose of this component is to support third party integrations that involving loading a script
 * and target a div on the page
 */

import React, {Component, PropTypes} from 'react';
import _ from 'lodash';
let scriptLoadingMapping = {};

class GenericScriptComponent extends Component {
  /**
   * dataProps covers any data attributes the script needs on the div
   */
  static propTypes = {
    scriptProps: React.PropTypes.shape({
      src: PropTypes.string.isRequired,
      async: PropTypes.bool,
      defer: PropTypes.bool,
      type: PropTypes.string,
      charset: PropTypes.string
    }),
    divProps: React.PropTypes.shape({
      targetDivId: PropTypes.string.isRequired,
      className: PropTypes.string,
      dataProps: PropTypes.object
    })

  };

  static defaultProps = {
    scriptProps: {
      async: true,
      defer: false,
      type: 'text/javascript'
    }
  };

  componentDidMount() {
    const {
      divProps: {
        targetDivId
      },
      scriptProps
    } = this.props;

    if (!(targetDivId in scriptLoadingMapping)) {
      const parent = document.getElementById(targetDivId);
      const child = document.createElement('script');
      _.assign(child, scriptProps);
      parent.appendChild(child);
      scriptLoadingMapping[targetDivId] = true;
    }
  }

  render() {
    const {
      divProps: {
        targetDivId,
        className,
        dataProps = {}
      }
    } = this.props;

    return (
      <div className={className} id={targetDivId} {...dataProps}></div>
    );
  }
}

export default GenericScriptComponent;



// WEBPACK FOOTER //
// ./app/components/GenericScriptComponent.js